export default "__VITE_ASSET__DfPHEsc2__"